import type { Table as TableType } from "@tanstack/table-core/build/lib/types";

import Button from "~/components/buttons/Button";

type PaginationProps<TableData> = {
    table: TableType<TableData>;
};

const Pagination = <TableData,>({ table }: PaginationProps<TableData>) => {
    const numberColumns = table.getVisibleFlatColumns().length;
    return (
        <>
            <tr className="h-[0.5px]">
                <td colSpan={numberColumns} className="bg-gray-200" />
            </tr>
            <tr>
                <td colSpan={numberColumns}>
                    <div className="flex w-full items-center justify-end overflow-hidden bg-white px-3 pb-1 pt-3">
                        <span className="mr-4 flex items-center gap-1 text-sm font-light">
                            <div>Seite</div>
                            <span className="font-normal">{table.getState().pagination.pageIndex + 1}</span>
                            <span>von</span>
                            <span className="font-normal">{table.getPageCount()}</span>
                        </span>
                        <div className="flex items-center gap-2">
                            <Button
                                theme="primary"
                                size="xs"
                                onClick={() => table.setPageIndex(0)}
                                disabled={!table.getCanPreviousPage()}
                            >
                                {"<<"}
                            </Button>
                            <Button
                                theme="primary"
                                size="xs"
                                onClick={() => table.previousPage()}
                                disabled={!table.getCanPreviousPage()}
                            >
                                {"<"}
                            </Button>
                            <Button
                                theme="primary"
                                size="xs"
                                onClick={() => table.nextPage()}
                                disabled={!table.getCanNextPage()}
                            >
                                {">"}
                            </Button>
                            <Button
                                theme="primary"
                                size="xs"
                                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                disabled={!table.getCanNextPage()}
                            >
                                {">>"}
                            </Button>
                        </div>
                    </div>
                </td>
            </tr>
        </>
    );
};

export default Pagination;
